export default __webpack_public_path__ + "static/media/BJS.f5c1c48e.gif";